document.addEventListener('DOMContentLoaded', function() {
    const forms = document.querySelectorAll('.ev-protected-content__password-form');

    forms.forEach(form => {
        if (form.dataset.hasListener) return;
        form.dataset.hasListener = 'true';

        let isSubmitting = false;

        form.addEventListener('submit', async function(e) {
            e.preventDefault();
            e.stopPropagation();

            if (isSubmitting) return;

            const passwordInput = this.querySelector('input[type="password"]');
            const nonceInput = this.querySelector('input[name="_wpnonce"]');

            if (!passwordInput.value.trim()) {
                alert(__('Please enter a password', 'ev-content-protection'));
                return;
            }

            isSubmitting = true;

            try {
                const formData = new FormData();
                formData.append('action', 'ev_verify_password');
                formData.append('block_id', this.closest('.ev-protected-content').dataset.blockId);
                formData.append('password', passwordInput.value);
                formData.append('_wpnonce', nonceInput.value);

                const response = await fetch(evContentProtection.ajaxurl, {
                    method: 'POST',
                    body: formData
                });

                const data = await response.json();

                if (data.success) {
                    location.reload();
                } else {
                    alert(data.data);
                }
            } catch (error) {
                console.error('Error:', error);
                alert(__('An error occurred', 'ev-content-protection'));
            } finally {
                isSubmitting = false;
            }
        });
    });
});
